import React, { useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { TKaikonZyutyuHaisyaListGetRes } from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import KaikonZyutyuHaisyaPatternService from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"

/**
 * 海コン受注配車パターン新規登録
 * @param param0
 * @returns
 */
const KaikonZyutyuHaisyaPatternRegisterModal: React.FC<
  Omit<TModalTypes, "title"> & {
    data: TKaikonZyutyuHaisyaListGetRes
  }
> = ({ data, ...modalProperties }) => {
  const [パターンコード, setパターンコード] = useState<string>("")
  const [isModalShow, setIsModalShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  return (
    <>
      <ModalOuter
        {...modalProperties}
        title="海コン受注配車パターン登録"
        size="sm"
        footer={
          <Button
            onClick={async () => {
              setAlertSource(undefined)
              if (パターンコード != null && data != null) {
                setIsModalShow(true)
              }
            }}>
            登録
          </Button>
        }>
        <Container fluid>
          <Row>
            <Col>
              <LocalAlertComponent alertSource={AlertSource} />
            </Col>
          </Row>
          <Row>
            <Col>
              <p>受注No.: {data?.受注伝票番号}</p>
              <div>
                パターンコード:{" "}
                <TextInput
                  name="パターンコード"
                  value={パターンコード}
                  setValue={setパターンコード}></TextInput>
              </div>
            </Col>
          </Row>
        </Container>
      </ModalOuter>
      <ConfirmModal
        isShow={isModalShow}
        hideHandler={setIsModalShow}
        submitHandler={async () => {
          try {
            //パターン登録
            const service = new KaikonZyutyuHaisyaPatternService()
            const res = await service.postPattern(data?.受注配車ID, {
              パターンコード: パターンコード,
            })

            modalProperties.setIsShow(false)
            if (res) {
              showInfoToast(`新規パターン${パターンコード}として登録しました。`)
            }
          } catch (error) {
            setAlertSource(error)
          } finally {
            setIsModalShow(false)
          }
        }}>
        <div>
          {data?.受注伝票番号 != null
            ? `受注No:${data.受注伝票番号}`
            : "選択行"}
          を{パターンコード}として登録します
        </div>
        <div>よろしいですか？</div>
      </ConfirmModal>
    </>
  )
}

export default KaikonZyutyuHaisyaPatternRegisterModal
